<template>
  <div class="order-menu-list">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <b-card header-tag="header" footer-tag="footer">
            <div slot="header">
              <i className="fa fa-align-justify"></i><strong class="text-uppercase">{{ $t('order-phil.orders') }}</strong>
            </div>
            <b-col cols="12" class="text-center">
              <b-row>
                <b-col cols="4">
                  <div class="pull-left mr-4">
                    <b-input-group v-bind:prepend="$t('order-phil.order_type')">
                      <b-form-select v-model="filter.order_type" v-bind:value="filter.order_type" :options="order_types[$session.get('lang')]" v-bind:placeholder="$t('order-phil.order_type')">
                      </b-form-select>
                    </b-input-group>
                  </div>
                </b-col>
                <b-col cols="4">
                  <b-input-group>
                    <select-dropdown v-bind:options="filter.options" v-bind:selected="filter.selected" position="prepend" v-bind:all="false" v-model="filter.field" prefix="order">
                    </select-dropdown>
                    <input type="text" class="form-control" v-model="filter.key" v-on:keydown.enter="refreshData"/>
                    <div class="input-group-append">
                      <b-input-group-append>
                        <b-btn @click="refreshData()"><i class="fa fa-search" ></i> {{$t('common.search')}}</b-btn>
                      </b-input-group-append>
                    </div>
                  </b-input-group>
                </b-col>
                <b-col cols="4">
                  <div class="pull-right">
                    <b-input-group v-bind:prepend="$t('order.created_at')">
                      <date-range-picker ref="drange" :startDate="filter.startAt" :endDate="filter.endAt" @update="updateDateRange" opens="left" :locale-data="date_locale" :ranges="ranges"></date-range-picker>
                    </b-input-group>
                  </div>
                </b-col>
                <b-col cols="4">
                  <b-input-group v-bind:prepend="$t('order.store_name')" class="pt-2">
                    <multiselect
                      class="select-filter-outlet"
                      v-model="filter.outlet_name"
                      label="text"
                      track-by="value"
                      :options="outletsList"
                      :multiple="false"
                      v-bind:selectLabel="$t('order.select_label')"
                      v-bind:deselectLabel="$t('order.select_remove')"
                      v-bind:selectedLabel="$t('order.selected')"
                    >
                    </multiselect>
                  </b-input-group>

                </b-col>
                <b-col cols="3">
                  <div class="pull-left">
                    <b-input-group v-bind:prepend="$t('order-phil.order_type')" class="pt-2">
                      <b-form-select v-model="filter.advance" v-bind:value="filter.advance" :options="advances[$session.get('lang')]">
                      </b-form-select>
                    </b-input-group>
                  </div>
                </b-col>
                <b-col cols="2">
                  <div class="pull-left">
                    <b-input-group v-bind:prepend="$t('order.sale_channel')" class="pt-2">
                      <b-form-select v-model="filter.sale_channel" v-bind:value="filter.sale_channel" :options="sale_channels[$session.get('lang')]">
                      </b-form-select>
                    </b-input-group>
                  </div>
                </b-col>
                <b-col cols="3">
                  <div class="pull-right mr-2 mrt-10">
                    <button v-if="dataTable.items.length > 0" type="button" class="btn border-radius-4px" :class="{'bg-main': true }" @click="exportData">
                      <span><i class="fa fa-download"></i>{{$t('common.export')}}</span>
                    </button>

                    <button type="button" class="btn border-radius-4px" :class="{'bg-main': !intervalLoadOrder}" @click="setIntetvalLoadOrder">
                      <span v-if="!intervalLoadOrder"><i class="fa fa-filter"></i> {{$t('common.auto_refresh')}}</span>
                      <span v-else><i class="fa fa-filter"></i> {{$t('common.stop_auto')}}</span>
                    </button>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <div class="table-responsive" :class="{ 'set-table-height': (dataTable.items.length<=4 && dataTable.items.length>0) }">
                  <table class="table table-striped table-hover table-sm table-bordered">
                    <thead>
                      <tr>
                        <th scope="col" v-for="item in dataTable.fields" :key="item.id" @click="updateSort(item.name)" v-show="checkShowByConfig(item.name)" :class="item.sort?'pointer':''">
                          <i class="fa fa-sort-amount-asc text-muted" v-if="dataTable.sort.type == 'asc' && dataTable.sort.field == item.name"></i>
                          <i class="fa fa-sort-amount-desc text-muted" v-if="dataTable.sort.type == 'desc' && dataTable.sort.field == item.name"></i>
                          <span v-if="item.label != null">{{$t('order.'+item.label)}}</span>
                          <span v-if="item.label == null">{{$t('order.'+item.name)}}</span>
                        </th>
                        <th scope="col" style="min-width: 240px">{{$t('common.action')}}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-if="dataTable.items.length == 0">
                        <td class="text-center" :colspan="dataTable.fields.length + 1">
                          {{$t('message.no_data')}}
                        </td>
                      </tr>
                      <tr v-for="item in dataTable.items" :key="item.id">
                        <td scope="row" class="text-left" v-for="field in dataTable.fields" :key="field.id" v-show="checkShowByConfig(field.name)">
                          <span :class="field.color&&field.color(item)" v-if="field.render != null" v-html="field.render(item[field.name], item)"></span>
                          <span :class="field.color&&field.color(item)" v-else>{{item[field.name]}}</span>
                        </td>
                        <td scope="row">
                          <div class="row">
                            <div class="col-md-6">
                              <b-button variant="primary" class="btn-action-view border-radius-4px bg-main" @click="showOrderDetail(item.uuid)">
                                <i class="fa fa-eye" aria-hidden="true"></i> {{$t('order.summary_view')}}
                              </b-button>
                            </div>
                            <div class="col-md-6">
                              <b-button variant="primary" class="btn-edit-cancel border-radius-4px bg-main" v-on:click="itemDetail(item.uuid)">
                                <i class="fa fa-edit"></i> {{$t('common.edit')}}
                              </b-button>
                            </div>
                          </div>

                          <div class="row">
                            <!-- <div class="col-md-6" v-show="order.config.proceed">
                              <b-dropdown variant="primary" split right text="Action">
                                <div>
                                  <b-dropdown-item  @click="showConfirmModal(item,10,'Process',false)"><i class="fa fa-spinner" aria-hidden="true" style="color:gray"></i>Process</b-dropdown-item>
                                  <b-dropdown-item  @click="showConfirmModal(item,11,'Process 30 mins',false)"><i class="fa fa-spinner" aria-hidden="true" style="color:gray"></i>Process 30 mins</b-dropdown-item>
                                  <b-dropdown-item  @click="showConfirmModal(item,12,'Process 45 mins',false)"><i class="fa fa-spinner" aria-hidden="true" style="color:gray"></i>Process 45 mins</b-dropdown-item>
                                  <b-dropdown-item  @click="showConfirmModal(item,13,'Process 45 mins No Gua',false)"><i class="fa fa-spinner" aria-hidden="true" style="color:gray"></i>Process 45 mins No Gua</b-dropdown-item>
                                  <b-dropdown-item  @click="showConfirmModal(item,14,'Process 60 mins',false)"><i class="fa fa-spinner" aria-hidden="true" style="color:gray"></i>Process 60 mins</b-dropdown-item>
                                  <b-dropdown-item @click="showConfirmModal(item,7,'Completed',false)"><i class="fa fa-check-square-o" aria-hidden="true" style="color:gray"></i>Completed</b-dropdown-item>
                                  <b-dropdown-item v-show="order.config.cancel && _.indexOf([7, 8, 9], item.status) < 0" @click="showConfirmModal(item,8,'Cancel',false)"><i class="fa fa-check-square-o" aria-hidden="true" style="color:gray"></i>Cancel</b-dropdown-item>
                                  <b-dropdown-item @click="print(item.uuid)"><i class="fa fa-print" aria-hidden="true" style="color:gray"></i>Print</b-dropdown-item>
                                  <b-dropdown-item @click="deliveryReceipt(item)" v-show="!showDeliveryReceipt(item)">
                                    <i class="fa fa-ship" aria-hidden="true" style="color:gray"></i>Delivery Receipt</b-dropdown-item>
                                  <b-dropdown-item :key="item.id+3" @click="showModalEmail(item,'email customer')"><i class="fa fa-envelope-o" aria-hidden="true" style="color:gray"></i>Email</b-dropdown-item>
                                </div>
                              </b-dropdown>
                            </div>
                            <div class="col-md-6" v-show="0 && order.config.cancel && _.indexOf([7, 8, 9], item.status) < 0">
                              <b-button variant="danger" class="btn-edit-cancel border-radius-4px" @click="showConfirmModal(item,8,'Cancel',false)">
                                <i class="fa fa-window-close"></i> {{$t('common.cancel')}}
                              </b-button>
                            </div> -->
                            <div class="col-md-6" v-show="order.config.proceed">
                              <b-button variant="primary" class="btn-edit-cancel border-radius-4px bg-main" v-on:click="showConfirmModal(item,7,'Completed',false)">
                                <i class="fa fa-edit"></i> {{$t('order.order_status_7')}}
                              </b-button>
                            </div>
                            <div class="col-md-6" v-show="order.config.proceed">
                              <b-button variant="primary" type="button" @click="processOrder(item.uuid, 2)"
                                        v-bind:class="{'btn-disable': (_.indexOf([4], item.status) < 0)}"
                                        :disabled="item.proceess || _.indexOf([4], item.status) < 0"
                                        v-show="order.config.resend && order.config.error_order"
                                        data-order-status="4" class="btn bg-main border-radius-4px">
                                {{$t('order.resend')}}
                              </b-button>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col-md-6" v-show="0 && order.config.resend">
                              <b-button variant="primary" class="btn-action-resend border-radius-4px bg-main" @click="resendToEios(item.uuid)">
                                <i class="fa fa-retweet" aria-hidden="true"></i> {{$t('order-phil.resend_to_eios')}}</b-button>
                            </div>

                            <div class="col-md-6" v-show="0 && checkShowByConfig('create_manually')">
                              <b-button variant="primary" class="btn-edit-manually border-radius-4px bg-main" v-on:click="createManually(item.uuid)">
                                <i class="fa fa-hand-rock-o"></i> {{$t('order-phil.create_manually')}}
                              </b-button>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </b-row>
              <b-row>
                <b-col>
                  <b-pagination :total-rows="dataTable.total" :per-page="dataTable.perPage" v-model="dataTable.currentPage" />
                </b-col>
                <b-col class="text-left">
                  {{$t('message.datatable_total', {number: dataTable.items.length, total: dataTable.total})}}
                </b-col>
                <b-col col lg="1">
                  <b-form-select v-model="dataTable.perPage" :options="[10, 20, 50, 100]" class="mb-3"/>
                </b-col>
              </b-row>
            </b-col>
          </b-card>
        </b-col>
      </b-row>
    </div>

    <div id="order_modal_detail" class="row" v-if="orderDetail">
      <b-modal class="view-modal-lg" size="huge" v-model="review_model" :hide-footer="true" :hide-header="true">
        <div class="row row-header">
          <div class="col-md-3">{{$t('order.orders')}}</div>
          <div class="col-md-3">{{$t('order.customer_detail')}}</div>
          <div class="col-md-4" v-show="checkShowByConfig('payment_method')">{{$t('order.order_detail')}}</div>
          <div class="col-md-2" v-show="checkShowByConfig('payment_status')">{{$t('common.action')}}
            <a href="javascript:void(0)" @click="showModalDetail=false;review_model = false;confirm_status=-1" class="close" style="font-size:35px;margin-top: -23px;">&times;</a>
          </div>
        </div>
        <div class="row row-content">
          <div class="col-md-3 col-content1">
            <div class="row">
              <div class="col"><strong>{{$t('order.order_number')}}</strong></div>
              <div class="col">{{orderDetail.order_number}}</div>
            </div>
            <div class="row" v-show="checkShowByConfig('street_address')">
              <div class="col"><strong>{{$t('order.delivery_address')}}</strong></div>
              <div class="col"><span v-if="orderDetail.order_type == 'D'">{{orderDetail.address}}</span></div>
            </div>
            <div class="row" v-show="checkShowByConfig('payment_method')">
              <div class="col"><strong>{{$t('order.payment_method')}}</strong></div>
              <div class="col">{{orderDetail.payment_method}}</div>
            </div>

            <div class="row" v-show="checkShowByConfig('payment_method')&&orderDetail.payment_method_code=='cash'&&orderDetail.payment_change_for">
              <div class="col"><strong>{{$t('order.payment_change_for')}}</strong></div>
              <div class="col">{{orderDetail.payment_change_for}}</div>
            </div>

            <div class="row" v-show="checkShowByConfig('processing')">
              <div class="col"><strong>{{$t('order.processing')}}</strong></div>
              <div class="col"><span v-if="orderDetail.assigned">{{orderDetail.assigned.name}}</span></div>
            </div>
            <div class="row" v-show="checkShowByConfig('payment_status')">
              <div class="col"><strong>{{$t('order.payment_status')}}</strong></div>
              <div class="col"><span v-if="orderDetail.order_payment">{{orderDetail.order_payment.status?"Paid":"Unpaid"}}</span></div>
            </div>

            <div class="row" v-show="checkShowByConfig('order_type')">
              <div class="col"><strong>{{$t('order.order_type')}}</strong></div>
              <div class="col">{{orderDetail.order_type=='D' ? this.$t('common.delivery') : (orderDetail.order_type == 'C' ? (orderDetail.referral_code == 'qr' ? $t('common.takeaway_qr') : $t('common.takeaway')) : "")}}</div>
            </div>
            <div class="row" v-show="checkShowByConfig('outlet_name')">
              <div class="col"><strong>{{$t('order.outlet_name')}}</strong></div>
              <div class="col">{{orderDetail.outlet_name}}</div>
            </div>
            <div class="row" v-show="checkShowByConfig('created_at')">
              <div class="col"><strong>{{$t('order.created_at')}}</strong></div>
              <div class="col"><span v-if="orderDetail.created_at">{{convertUTCToTimeZone(orderDetail.created_at, orderDetail.outlet_timezone).format('YYYY-MM-DD HH:mm:ss')}}</span></div>
            </div>
            <div class="row" v-show="checkShowByConfig('collection_time')">
              <div class="col"><strong>{{$t('order.collection_time')}}</strong></div>
              <div class="col"><span v-if="orderDetail.collection_time">{{convertUTCToTimeZone(orderDetail.collection_time, orderDetail.outlet_timezone).format('YYYY-MM-DD HH:mm:ss')}}</span></div>
            </div>
            <div class="row" v-show="checkShowByConfig('advance_order')">
              <div class="col"><strong>{{$t('order.advance_order')}}</strong></div>
              <div class="col"><span>{{orderDetail.advance_order>0?"Yes":"No"}}</span></div>
            </div>
          </div>
          <div class="col-md-3 col-content2">
            <div class="row">
              <div class='wrap pl-3'>
                <div class = "blocks">
                  <i class="fa fa-user"></i>&nbsp; {{orderDetail.name}}
                </div>

                <div class = "blocks">
                  <i class="fa fa-envelope"></i>&nbsp; {{orderDetail.email}}
                </div>

                <div class = "blocks">
                  <i class="fa fa-phone"></i>&nbsp; {{orderDetail.phone}}
                </div>

                <div class = "blocks">
                  <i class="fa fa-home"></i>&nbsp; {{orderDetail.address}}
                </div>

                <div class = "blocks" v-show="checkShowByConfig('senior_citizen_id')&&orderDetail.senior_citizen_id">Citizen ID: {{orderDetail.senior_citizen_id}}
                </div>

                <div class = "blocks" v-show="checkShowByConfig('pwd_id')&&orderDetail.pwd_id">PWD ID: {{orderDetail.pwd_id}}
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4 col-content3">
            <div class="wrap">
              <div class="blocks">
                <div v-for="(item,index) in orderDetail.order_items" :key="index+0" class="order-details">
                  <div v-if="item.type == 0">
                    <div v-for="(sub_item, sub_index) in item.items" :key="sub_index+0">
                      <div class="item-row">
                        <div class="item-name  pl-2">
                          <strong><span v-if="sub_item.quantity > 1">{{sub_item.quantity}} x </span> {{sub_item.name}}</strong>
                        </div>
                        <div class="item-price"><strong>{{sub_item.total}} ({{currency.symbol}})</strong></div>
                      </div>
                      <div class="item-row" v-if="sub_item.first.uuid != '' && sub_item.first.second.uuid != ''">
                        <div class="option-name  pl-3">{{sub_item.first.name}} - {{sub_item.first.second.name}}</div>
                        <div class="item-price">{{sub_item.first.price + sub_item.first.second.price}} ({{currency.symbol}})</div>
                      </div>
                      <div class="item-row" v-for="(topping,index) in sub_item.topping.extra" :key="index+0">
                        <div class="topping-name  pl-4">{{$t('common.add')}} {{topping.name}}</div>
                        <div class="item-price">{{topping.price  * topping.quantity}} ({{currency.symbol}})</div>
                      </div>
                      <div class="item-row" v-for="(topping,index) in sub_item.topping.remove" :key="index+0">
                        <div class="topping-name  pl-4">{{$t('common.remove')}} {{topping.name}}</div>
                        <div class="item-price"></div>
                      </div>
                    </div>
                  </div>
                  <div v-else-if="item.type == 2">
                    <div class="item-row">
                      <div class="item-name">
                        <strong><span v-if="item.quantity > 1">{{item.quantity}} x </span> {{item.name}} </strong>
                      </div>
                      <div class="item-price"><strong>{{item.total}} ({{currency.symbol}})</strong></div>
                    </div>
                    <div v-for="(sub_item, sub_index) in item.items" :key="sub_index+0">
                      <div class="item-row">
                        <div class="item-name pl-2">
                          {{ (sub_index % 2 == 0) ? $t('orders.left_half') : $t('orders.right_half')}}
                        </div>
                        <div class="item-name pl-3">
                          <strong>{{sub_item.name}}</strong>
                        </div>
                      </div>
                      <div class="item-row" v-if="sub_item.first.uuid != '' && sub_item.first.second.uuid != ''">
                        <div class="option-name pl-4">{{sub_item.first.name}} - {{sub_item.first.second.name}}</div>
                        <div class="item-price">{{sub_item.first.price + sub_item.first.second.price}} ({{currency.symbol}})</div>
                      </div>
                      <div class="item-row" v-for="(topping,index) in sub_item.topping.extra" :key="index+0">
                        <div class="topping-name pl-5">{{$t('common.add')}} {{topping.name}}</div>
                        <div class="item-price">{{topping.price  * topping.quantity}} ({{currency.symbol}})</div>
                      </div>
                      <div class="item-row" v-for="(topping,index) in sub_item.topping.remove" :key="index+0">
                        <div class="topping-name pl-5">{{$t('common.remove')}} {{topping.name}}</div>
                        <div class="item-price"></div>
                      </div>
                    </div>
                  </div>
                  <div v-else-if="item.type == 1">
                    <div class="item-row">
                      <div class="item-name">
                        <strong><span>{{item.quantity}} x </span> {{item.name}}</strong>
                      </div>
                      <div class="item-price"><strong>{{item.base_price}} ({{currency.symbol}})</strong></div>
                    </div>
                    <div v-for="(sub_item, sub_index) in item.items" :key="sub_index+0">
                      <div class="item-row">
                        <div class="item-name pl-2">
                          <span>{{sub_item.quantity}} x </span> {{sub_item.name}}
                        </div>
                        <div class="item-price">{{sub_item.base_price}} ({{currency.symbol}})</div>
                      </div>
                      <div class="item-row" v-if="sub_item.first.uuid != '' && sub_item.first.second.uuid != ''">
                        <div class="option-name  pl-3">{{sub_item.first.name}} - {{sub_item.first.second.name}}</div>
                        <div class="item-price">{{sub_item.first.price + sub_item.first.second.price}} ({{currency.symbol}})</div>
                      </div>
                      <div class="item-row" v-else-if="sub_item.first.uuid != ''">
                        <div class="option-name  pl-3">{{sub_item.first.name}}</div>
                        <div class="item-price">{{sub_item.first.price}} ({{currency.symbol}})</div>
                      </div>
                      <div class="item-row" v-for="(topping,index) in sub_item.topping.extra" :key="index+0">
                        <div class="topping-name  pl-4">{{$t('common.add')}} {{topping.name}}</div>
                        <div class="item-price">{{topping.price  * topping.quantity}} ({{currency.symbol}})</div>
                      </div>
                      <div class="item-row" v-for="(topping,index) in sub_item.topping.remove" :key="index+0">
                        <div class="topping-name  pl-4">{{$t('common.remove')}} {{topping.name}}</div>
                        <div class="item-price"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="clearfix"></div>
              <hr>
              <div class="order-details">
                <div class="item-row">
                  <div class="item-name">
                    <strong>{{$t('order.total')}}</strong>
                  </div>
                  <div class="item-price"><strong>{{orderDetail.total}} ({{currency.symbol}})</strong></div>
                </div>
              </div>
              <div class="clearfix"></div>
              <hr v-if="orderDetail.note!=null">

              <div class="blocks" v-if="orderDetail.note!=null">
                <a class="btn btn-danger btn-xs btn-note">{{$t('order.order_note')}}</a>
              </div>
              <div class="blocks" v-if="orderDetail.note!=null">
                <li class="li-note">{{orderDetail.note}}</li>
              </div>
            </div>
          </div>
          <!-- <div class="col-md-2 col-content4">
            <div class="col-sm-12">
              <div class="pt-2" v-show="order.config.proceed">
                <b-button-group>
                  <b-dropdown right split variant="primary" text="Process">
                    <div>
                      <b-dropdown-item @click="showConfirmModal(orderDetail,11,'Process 30 mins',true)"><i class="fa fa-spinner" aria-hidden="true" style="color:gray"></i>Process 30 mins</b-dropdown-item>
                      <b-dropdown-item @click="showConfirmModal(orderDetail,12,'Process 45 mins',true)"><i class="fa fa-spinner" aria-hidden="true" style="color:gray"></i>Process 45 mins</b-dropdown-item>
                      <b-dropdown-item @click="showConfirmModal(orderDetail,13,'Process 45 mins No Gua',true)"><i class="fa fa-spinner" aria-hidden="true" style="color:gray"></i>Process 45 mins No Gua</b-dropdown-item>
                      <b-dropdown-item @click="showConfirmModal(orderDetail,14,'Process 60 mins',true)"><i class="fa fa-spinner" aria-hidden="true" style="color:gray"></i>Process 60 mins</b-dropdown-item>
                    </div>
                  </b-dropdown>
                </b-button-group>
              </div>
              <div v-show="0 && order.config.cancel && _.indexOf([7, 8, 9], orderDetail.status) < 0" class="pt-2">
                <b-button variant="danger" class="btn-edit-cancel border-radius-4px" @click="showConfirmModal(orderDetail,8,'Cancel',true)">
                  <i class="fa fa-window-close"></i> {{$t('common.cancel_order')}}
                </b-button>
              </div>
            </div>
          </div> -->
        </div>
        <div class="row row-process pt-2" v-show="showModalDetail">
          <div class="col-md-12"><strong>{{confirm_title.toUpperCase()}}</strong></div>
        </div>
        <div class="row row-confirm-detail" v-show="showModalDetail">
          <div class="col-md-12" v-if="confirm_status==8">
            <div class="row store-operation">
              <label class="control-label col-sm-3">{{$t('confirm_order.report_to_manager')}}</label>
              <div class="col-sm-9">
                <b-form-textarea id="textarea_reason" v-model="text_reason" :placeholder="$t('confirm_order.cancel_reason')" rows="3" max-rows="6"></b-form-textarea>
              </div>
            </div>
          </div>
          <div class="col-md-12" v-else>
            <div class="row confirm-address">
              <strong class="control-label col-sm-3">{{$t('confirm_order.confirm_address')}}</strong>
              <div class="col-sm-9">
                <span>{{confirm_address}}</span>
              </div>
            </div>
            <div class="row store-operation">
              <label class="control-label col-sm-3">{{$t('confirm_order.store_operation')}}</label>
              <div class="col-sm-9">
                <model-select :options="outlet_selected_options"
                                  v-model="outlet_selected_item"
                                  placeholder="Select Outlet">
                </model-select>
              </div>
            </div>
          </div>
        </div>
        <div class="row row-footer pull-right" v-show="showModalDetail">
          <div class="col-sm-12">
            <b-button class="mt-2" @click="showModalDetail=false;confirm_status=-1" variant="light" >{{$t('common.cancel')}}</b-button>
            <b-button class="mt-2" @click="confirmOrder();review_model = false;showModalDetail=false" variant="primary">{{$t('confirm_order.confirm_button')}}</b-button>
          </div>
        </div>
      </b-modal>
    </div>

    <div id="modal_print_order" class="row" v-if="orderDetail">
      <b-modal class="view-modal-lg" title="Review order detail before print" size="huge-extra"
      v-model="print_model" @ok="print_model = false" :hide-footer="true">
        <div id="export_to_pdf"></div>
      </b-modal>
    </div>

    <div id="modal_confirm_before_process" class="row" v-if="orderDetail">
      <b-modal size="lg" :title="confirm_title.toUpperCase()" v-model="confirm_model" @ok="confirmOrder();confirm_model = false" :ok-title="'Confirm'">
        <div>
          <div class="row confirm-address">
            <label class="control-label col-sm-3">{{$t('confirm_order.confirm_address')}}</label>
            <div class="col-sm-9">
              <span>{{confirm_address}}</span>
            </div>
          </div>
          <div class="row store-operation">
            <label class="control-label col-sm-3">{{$t('confirm_order.store_operation')}}</label>
            <div class="col-sm-9">
              <model-select :options="outlet_selected_options"
                                v-model="outlet_selected_item"
                                placeholder="Select Outlet">
              </model-select>
            </div>
          </div>
        </div>
      </b-modal>
    </div>

    <div id="modal_cancel_order" v-if="orderDetail">
      <b-modal class="row" size="lg" :title="confirm_title.toUpperCase()" v-model="cancel_model" @ok="confirmOrder()" :ok-title="'Confirm'">
        <div>
          <div class="row store-operation">
            <label class="control-label col-sm-3">{{$t('confirm_order.report_to_manager')}}</label>
            <div class="col-sm-9">
              <b-form-textarea
                id="textarea_reason"
                v-model="text_reason"
                :placeholder="$t('confirm_order.cancel_reason')"
                rows="3"
                max-rows="6">
              </b-form-textarea>
            </div>

          </div>
        </div>
      </b-modal>
    </div>

    <div id="modal_email_order" v-if="orderDetail">
      <b-modal class="row" size="huge" :title="confirm_title.toUpperCase()" v-model="email_model" :ok-title="'Send Now'" hide-footer>
        <div>
          <div class="row">
            <label class="control-label col-sm-2">Subject</label>
            <div class="col-sm-10">
              <b-form-input v-model.trim="email_form.subject" maxlength="200"
              v-on:input="$v.email_form.subject.$touch" placeholder="Enter your subject"></b-form-input>
              <div v-if="$v.$error">
                <div class="text-danger" v-if="!$v.email_form.subject.required">Subject is required</div>
              </div>
            </div>
          </div>
          <div class="row">
            <label class="control-label col-sm-2">E-Mail Send To</label>
            <div class="col-sm-10">
              <b-form-input v-model.trim="email_form.sendto" maxlength="100"
              v-on:input="$v.email_form.sendto.$touch" placeholder="Send to E-mail"></b-form-input>
              <div v-if="$v.$error">
                <div class="text-danger" v-if="!$v.email_form.sendto.required">Send to is required</div>
              </div>
            </div>
          </div>
          <div class="row">
            <label class="control-label col-sm-2">E-Mail Template</label>
            <div class="col-sm-10">
              <b-form-select v-model="email_form.selected_template"
              v-on:input="$v.email_form.selected_template.$touch" :options="template_options"
              @change="templateChange($event)">
              </b-form-select>
              <div v-if="$v.$error">
                <div class="text-danger" v-if="!$v.email_form.selected_template.required">Please choose template</div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <ckeditor :language="$session.get('lang')" v-model="email_form.content"
              :id="'EmailTemplate'" :height="'400px'" :client="client" :x-token="xToken"></ckeditor>
              <div v-if="$v.$error">
                <div class="text-danger" v-if="!$v.email_form.content.required">Email content is required</div>
              </div>
            </div>
          </div>
          <div class="row pull-right">
            <div class="col-sm-12">
              <b-button class="mt-2" @click="email_model=false" variant="light">Cancel</b-button>
              <b-button class="mt-2" @click="sendEmail()" variant="primary">Send Now</b-button>
            </div>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>
<script>
import SelectDropdown from '../../../components/Partials/SelectDropdown'
import DataTable from '../../../components/Partials/DataTable'
import DateRangePicker from 'vue2-daterange-picker'
import axios from 'axios'
import pdfobj from 'pdfobject'
import { ModelSelect } from 'vue-search-select'
import {validationMixin} from 'vuelidate'
import {email,required,maxLength} from 'vuelidate/lib/validators'
import Ckeditor from '../../editors/CKEditor'
import Multiselect from 'vue-multiselect'
import { ExportToCsv } from 'export-to-csv';

const CancelToken = axios.CancelToken
let cancel = null
let vm = null
export default {
  name: 'ListErrors',
  mixins: [
    validationMixin
  ],
  validations: {
    email_form:{
      subject:{
        required,
        maxLength: maxLength(200)
      },
      sendto:{
        email,
        required,
        maxLength: maxLength(100)
      },
      selected_template:{
        required
      },
      content:{
        required
      }
    }
  },
  components: {
    SelectDropdown,
    DateRangePicker,
    DataTable,
    Multiselect,
    ModelSelect,
    Ckeditor
  },
  data: function () {
    return {
      isNzMarket: false,
      intervalLoadOrder: null,
      currency: this.$store.getters.config.gms.currency_info,
      order: this.$store.getters.config.gms.order,
      outletsList: [],
      orderDetail:{},
      review_model: false,
      confirm_model:false,
      cancel_model:false,
      email_model:false,
      print_model:false,
      type: 'like',
      statuses: [],
      advances: [],
      order_types: [],
      sale_channels: [],
      date: [],
      filter: {
        options: [],
        startAt: this.$moment().format('YYYY-MM-DD'),//this.$moment().subtract(30,'day').format('YYYY-MM-DD'),
        endAt: this.$moment().format('YYYY-MM-DD'),
        selected: null,
        status: '',
        outlet_name: '',
        order_type: '',
        sale_channel: '',
        code: '',
        field: null,
        key: null,
        advance: '',
      },
      dataTable: {
        items: [],
        fields: [
          {
            name: 'order_reference',// sing
            filter: false,
            sort: false,
            render: (data, row) => {
              if(data==null) return ''
              return data.name
            }
          },
          {
            name: 'order_status', //phils,japan
            label: 'status',
            filter: false,
            sort: false,
            render: (data, row) => {
              if(data==null) return ''
              let text= typeof data.json_name !== "undefined" ? data.json_name[this.$session.get('lang') || 'en'] : data.name
              if(row.customize.is_not_refund == 1) {
                text = this.$t('order.order_status_24')
              }
              return text
            },
            color:(row)=>{
              switch (row.status) {
                case 2:
                  return 'badge badge-pill status-ordered-red';
                case 8:
                  return 'badge badge-pill status-cancelled-gray';
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                  return 'badge badge-pill status-processed-green';
              }
            }
          },
          {
            name: 'order_number',//phils,japan,sing
            filter: true,
            sort: true,
            render: (data, row) => {
              if (data == null) {
                return ''
              }

              let str=row.order_number
              if(this.checkShowByConfig('advance_order')&&row.advance_order){
                str+='<br/><a href="#" class="badge badge-pill badge-primary">'+this.$t('order.advance_order')+'<a>'
              }

              return str
            }
          },
          {
            label: 'customer_detail',// sing
            name: 'customer_detail',
            filter: false,
            sort: false,
            render: (data, row) => {
              let str=row.name + ' <br/> ' + row.email + ' <br/> ' + row.phone
              if(this.checkShowByConfig('senior_citizen_id')&&row.senior_citizen_id){
                str+=' <br/> Citizen ID:' + row.senior_citizen_id
              }

              if(this.checkShowByConfig('pwd_id')&&row.pwd_id){
                str+=' <br/> PWD ID:' + row.pwd_id
              }

              return str
            }
          },
          {
            name: 'name',//phils,japan
            filter: true,
            sort: false,
            render: (data, row) => {
              if (data == null) {
                return ''
              }
              return data
            }
          },
          {
            name: 'email',//phils,japan
            filter: true,
            sort: false,
            render: (data, row) => {
              if (data == null) {
                return ''
              }
              return data
            }
          },
          {
            name: 'phone',//phils,japan
            filter: true,
            sort: false,
            render: (data, row) => {
              if (data == null) {
                return ''
              }
              return data
            }
          },
          {
            name: 'order_type',//phils,japan,sing
            filter: false,
            sort: false,
            render: (data, row) => {
              if (data == null) {
                return ''
              }
              let type;
              if (data == 'D') {
                type = vm.$t('common.delivery')
              }
              if (data == 'C') {
                type = vm.$t('common.takeaway')
                if (row.referral_code === 'qr') {
                  type = vm.$t('common.takeaway_qr')
                }
              }
              return type
            }
          },
          {
            name: 'outlet_name',//phils,japan
            filter: false,
            sort: false,
            render: (data, row) => {
              if (data == null) {
                return ''
              }
              return row.outlet_code + '  ' + data
            }
          },
          {
            name: 'channel', // phils,japan
            label: 'sale_channel', // phils,japan
            filter: false,
            sort: false,
            render: (data, row) => {
              if (data == null) {
                return ''
              }
              return data
            }
          },
          {
            name: 'payment_method',// sing,phils
            filter: false,
            sort: false,
            render: (data, row) => {
              if(data==null) return ''
              return row.payment_method
            },
            color:(row)=>{
              switch (row.payment_method_code) {
                case 'credit_card':
                  return 'badge badge-pill payment-method-credit';
                case 'swipe':
                  return 'badge badge-pill payment-method-swipe';
              }
            }
          },
          {
            name: 'payment_status',// phils
            filter: false,
            sort: false,
            render: (data, row) => {
              if(row.order_payment.status){
                return 'Paid'
              }

              return 'Unpaid'
            }
          },
          {
            name: 'store_delivery_address',// sing
            filter: false,
            sort: false,
            render: (data, row) => {
              return row.outlet_address + ', #' + row.address
            }
          },
          {
            name: 'eios_sending_log',// sing
            filter: false,
            sort: false,
            render: (data, row) => {
              if (data == null) {
                return ''
              }
              return row.outlet_code + '  ' + data
            }
          },
          {
            name: 'pos_error_response',// peru
            filter: false,
            sort: false,
            render: (data, row) => {
              const reasons = row.pos_response ?
                row.pos_response.filter(x => x.status == 3 && /error/i.test(x.message) && !x.message.includes('error_code')) :
                null
              const posErrorResponses = reasons ? reasons.map((reason) => {
                const message = reason ? (this.extractJSON(reason.message) ? this.extractJSON(reason.message)[0] : reason.message) : null
                return message ? (message.errorDescription || (reason.message ? decodeURIComponent(encodeURIComponent(reason.message.replace(/<(.|\n)*?>/g, ''))) : '')): ''
              }) : null
              return posErrorResponses ? this._.uniq(posErrorResponses).join('<br /><br />') : (
                ''
              )
            }
          },
          {
            name: 'total',//phils,japan
            filter: false,
            sort: false,
            render: (data, row) => {
              if (data == null) {
                return ''
              }
              return new Intl.NumberFormat().format(data) + ' ' + this.$t('order.'+row.currency)
            }
          },
          {
            name: 'created_at',//phils,japan
            filter: false,
            sort: true,
            render: (data, row) => {
              if (data == null) {
                return ''
              }
              let timezone = row.outlet_timezone
              return this.convertUTCToTimeZone(data, timezone) ? this.convertUTCToTimeZone(data, timezone).format( this.$store.getters.config.main.date_format ? this.$store.getters.config.main.date_format.toUpperCase() + " HH:mm:ss" : 'DD/MM/YYYY HH:mm:ss') : data
            }
          },
          {
            name: 'collection_time', // phils,japan
            filter: false,
            sort: true,
            render: (data, row) => {
              if (data == null) {
                return ''
              }
              let timezone = row.outlet_timezone
              return this.convertUTCToTimeZone(data, timezone) ? this.convertUTCToTimeZone(data, timezone).format(this.$store.getters.config.main.date_format ? this.$store.getters.config.main.date_format.toUpperCase() + " HH:mm:ss" : 'DD/MM/YYYY HH:mm:ss') : data
            }
          },
          {
            name: 'assigned',//phils,japan
            filter: false,
            sort: true,
            render: (data, row) => {
              if (data == null) {
                return ''
              }
              return data.name
            }
          },
          {
            name: 'processed_at',//phils
            filter: false,
            sort: true,
            render: (data, row) => {
              if (data == null) {
                return ''
              }
              let timezone = row.outlet_timezone
              return this.convertUTCToTimeZone(data, timezone) ? this.convertUTCToTimeZone(data, timezone).format( this.$store.getters.config.main.date_format ? this.$store.getters.config.main.date_format.toUpperCase() + " HH:mm:ss" : 'DD/MM/YYYY HH:mm:ss') : data
            }
          }
        ],
        sort: {
          field: 'updated_at',
          type: 'desc'
        },
        currentPage: 1,
        total: 0,
        perPage: 10,
        source: null
      },
      email_form:{
        subject:'',
        sendto:'',
        title:'',
        content:'',
        selected_template: null
      },
      template_options:[],
      item: {},
      outlet_selected_options: [],
      outlet_selected_item: {},
      confirm_address:'',
      confirm_status:-1,
      confirm_uuid:'',
      confirm_outlet:'',
      confirm_title:'',
      text_reason:'',
      xToken: '',
      client: localStorage.getItem('clientID'),
      showModalDetail:false
    }
  },
  methods: {
    processOrder (uuid, status) {
      var vm = this
      var uuidKey = uuid;
      var statusKey = status
      let options = {
        html: true,
        okText: this.$t('common.ok'),
        cancelText: this.$t('common.cancel')
      }
      let title = this.$t('order.confirm_title_change_status')
      if (status == 2) {
        title = this.$t('order.confirm_title_resend_status')
      }
      this.$dialog.confirm(title, options)
        .then(function (dialog) {
          vm.axios.order.getOrderDetailForProcessAction(uuidKey, {status: statusKey},
            function (response) {
              let data=response.data.data.item
              console.log(data)
              if(data){
                let item=_.find(vm.dataTable.items, {uuid: uuidKey});
                var index = vm.dataTable.items.indexOf(item);
                if (index > -1) {
                  vm.dataTable.items.splice(index, 1);
                  vm.dataTable.total -= 1
                }
              }
            })
        }).catch(function() {
      })
    },
    setIntetvalLoadOrder() {
      if (!this.intervalLoadOrder) {
       this.intervalLoadOrder = setInterval(function () {
          vm.refreshData()
        }, 10000)
        return false
      } else {
        clearInterval(this.intervalLoadOrder)
        this.intervalLoadOrder = null
      }
    },
    exportData() {
      vm.$bus.$emit('loading', 'block')
      const options = {
        fieldSeparator: ',',
        quoteStrings: '"',
        decimalSeparator: '.',
        showLabels: true,
        filename: `order_errors_${this.$moment().format('YYYY-MM-DD')}`,
        useKeysAsHeaders: true,
        // headers: ['Column 1', 'Column 2', etc...] <-- Won't work with useKeysAsHeaders present!
      };

      const csvExporter = new ExportToCsv(options);

      this.setupQuery(
      {
        dataTable: {
          ...this.dataTable,
          perPage: 999999,
          currentPage: 1
        },
        filter: this.filter
      },
      (response) => {
        this.$bus.$emit('loading', 'none')
        this.$toastr.success(this.$t('message.export_success'), this.$t('message.success'), {})

        const data = response.data.data.items.map( item => {
          const newItem = {};

          this.dataTable.fields.forEach( field => {
            if(field.render != null){
              const label = field.label ? this.$t('order.'+field.label) : this.$t('order.'+field.name)
              const val = field.render(item[field.name], item);

              newItem[label] = val
            }
          })
           if (this.isNzMarket) {
            if (newItem.hasOwnProperty('Customer Details')) {
              delete newItem['Customer Details']
            }

            if (newItem.hasOwnProperty('Order ID')) {
              newItem['Order ID'] = newItem['Order ID'].split('<br/>')[0]
            }
          }
          return newItem;
        });

        csvExporter.generateCsv(data);
      }, (err) => {
        this.$bus.$emit('loading', 'none')
        this.$toastr.error(this.$t('message.export_fail'), this.$t('message.error'), {})
      })
    },
    templateChange(event){
      let vm=this
      vm.axios.order.getEmailTemplateByUuid(event,function (response) {
        let result=response.data.data
        if(result){
          vm.email_form.content=result.content
        }
      })
    },
    listEmailTemplate(){
      let vm=this
      vm.axios.order.listEmailTemplate(function (response) {
        let result=response.data.items
        if(result){
          vm.template_options.push({ value: null, text: 'Please select an template' })
          for (let i in result) {
            vm.template_options.push({value: result[i].uuid,text: result[i].title})
          }
        }
      })
    },
    showDeliveryReceipt(item){
      return (item.payment_method_code=='cash'||item.payment_method_code=='swipe')
    },
    /**
     * convert date format then refresh data when date range update
     * @param val
     */
    updateDateRange (val) {
      this.date = val
      this.filter.startAt = val.startDate != null ? this.$moment(val.startDate).format('YYYY-MM-DD') : this.$moment().subtract(7, 'days').format('YYYY-MM-DD')
      this.filter.endAt = val.endDate != null ? this.$moment(val.endDate).format('YYYY-MM-DD') : this.$moment().format('YYYY-MM-DD')
      this.refreshData()
    },
    checkShowByConfig (key) {
      if (this.order == null) {
        return true
      }
      if (key == 'pos_error_response') {
        return this.order.config ? this.order.config.pos_error_response : false
      }
      let config = this._.find(this.order.list, function (o) {
        return o.type === key
      })
      if (config == null) {
        return true
      }
      return config.show
    },
    deliveryReceipt(item){},
    resendToEios(item){},
    createManually(item){},
    showModalEmail(item,title){
      vm=this
      vm.confirm_title=title

      vm.email_model = true
      vm.listEmailTemplate()
    },
    sendEmail(){
      let vm=this
      vm.$v.email_form.$touch()
      if (!vm.$v.email_form.$invalid) {
        vm.axios.order.sendEmailTemplate(vm.email_form,function (response) {
            if(response.data){
              vm.$toastr.success(vm.$t('message.send_email_successful'), vm.$t('message.success'), {})
              vm.email_form.subject=''
              vm.email_form.title=''
              vm.email_form.content=''
              vm.email_form.sendto=''
              vm.email_form.selected_template=null
            }

            vm.email_model = false
        }, error => {
          console.log(error)
          main.$toastr.error(vm.$t('message.send_email_fail'), main.$t('message.error'), {})
          vm.email_model = false
        })
      }
    },
    print(uuid){
      vm = this;
      vm.print_model=true
      vm.axios.order.printOrderDetail(uuid,
      function (response) {
        let blob = new Blob([response.data], { type: 'application/pdf' })
        vm.src=window.URL.createObjectURL(blob)
        pdfobj.embed(vm.src, "#export_to_pdf")
      })
    },
    showConfirmModal(item,status,title,modal){
      let vm=this
      vm.confirm_status=status
      vm.confirm_title=title
      vm.confirm_uuid=item.uuid
      vm.confirm_address=item.address
      if(modal){
        vm.showModalDetail=true
        vm.getListOutletOption(item.outlet_code)
      }else{
        if(status==8){
          vm.cancel_model = true
        }else{
          vm.confirm_model = true;
          vm.getListOutletOption(item.outlet_code)
        }
      }
    },

    getListOutletOption(outlet_code){
      vm.outlet_selected_item={value:outlet_code,name:''}
      // get store list
      vm.axios.outlet.getStoreListUnlimit('?disposition=ALL', function (respone) {
        let result = respone.data.data.items
        for (let i in result) {
          vm.outlet_selected_options.push({text: result[i].name, value: result[i].code})
        }
      }, error => {
        console.log(error)
      })
    },

    confirmOrder(){
      let vm=this
      if(vm.confirm_status>-1){
        vm.axios.order.getOrderDetailForProcessAction(vm.confirm_uuid,
        {status : vm.confirm_status,outlet_code:vm.outlet_selected_item.value,note:vm.text_reason},
        function (response) {
          vm.$toastr.success(vm.$t('message.update_successful'), vm.$t('message.success'), {})
          let data=response.data.data.item
          if(data){
            //get item from current list
            let item=_.find(vm.dataTable.items, {uuid:vm.confirm_uuid});
            if(item){
              item.order_status=data.order_status
              item.status=data.status
              item.assigned=data.assigned
            }
          }

          vm.text_reason=''
          vm.confirm_status=1
        }, error => {
          vm.confirm_status=1
          console.log(error)
        })
      }

      vm.confirm_model=false
    },
    confirmOrder(){
      let vm=this
      if(vm.confirm_status>-1){
        vm.axios.order.getOrderDetailForProcessAction(vm.confirm_uuid,{status : vm.confirm_status,outlet_code:vm.outlet_selected_item.value},
        function (response) {
          vm.$toastr.success(vm.$t('message.update_successful'), vm.$t('message.success'), {})
          let data=response.data.data.item
          if(data){
            //get item from current list
            let item=_.find(vm.dataTable.items, {uuid:vm.confirm_uuid});
            var index = vm.dataTable.items.indexOf(item);
            if (index > -1) {
              vm.dataTable.items.splice(index, 1);
              vm.dataTable.total -= 1
            }
          }
        })
      }

      vm.confirm_model=false
    },
    showOrderDetail(uuid){
      let app=this
      app.review_model = true;
      app.axios.order.getOrderDetail(uuid,
      function (response) {
          app.orderDetail = response.data.data.item
      })
    },
    itemDetail (uuid) {
      this.$router.push({name: 'order_detail', params: { uuid: uuid }})
    },
    updateSort: function (field) {
      for (let i in this.dataTable.fields) {
        if (this.dataTable.fields[i].name == field && (this.dataTable.fields[i].sort == null || this.dataTable.fields[i].sort == false)) {
          return
        }
      }
      if (this.dataTable.sort.field != field) {
        this.dataTable.sort = {
          field: field,
          type: 'asc'
        }
      } else {
        if (this.dataTable.sort.type == 'asc') {
          this.dataTable.sort = {
            field: field,
            type: 'desc'
          }
        } else {
          this.dataTable.sort = {
            field: field,
            type: 'asc'
          }
        }
      }

      this.refreshData()
    },
    setupQuery: function(options, cb, err){
      let search = "";

      const { filter, dataTable } = options;

      if (!this._.isEmpty(filter.field) && !this._.isEmpty(filter.key)) {
        search = "&"+ filter.field + "=" + filter.key.trim()
      }

      search = search + '&status=4'

      if (filter.advance != '') {
        search = search + '&advance_order=' + filter.advance
      }
      if (filter.order_type != '') {
        search = search + '&order_type=' + filter.order_type
      }

      if (filter.sale_channel != '') {
        search = search + '&channel=' + filter.sale_channel
      }


      if (!this._.isEmpty(filter.outlet_name)) {
        search = search + '&outlet_name=' + filter.outlet_name.value || ''
      }

      let params = '?limit=' + dataTable.perPage + '&page=' + dataTable.currentPage + '&sort_by=' + dataTable.sort.field + '&order_by=' + dataTable.sort.type + search + '&order_time_from=' + this.$moment(filter.startAt + ' 00:00:00').utc().format('YYYY-MM-DD HH:mm:ss') + '&order_time_to=' + this.$moment(filter.endAt + ' 23:59:59').utc().format('YYYY-MM-DD HH:mm:ss')
      this.axios.order.getOrderList(params, {
          cancelToken: new CancelToken(function executor(c) {
            cancel = c
          })
        },cb, err);
    },
    /**
     * Refesh data
    */
    refreshData: function () {
      if (cancel != null) {
        cancel()
      }

      this.setupQuery(
        this,
        function (response) {
            vm.dataTable.items = response.data.data.items
            vm.dataTable.total = response.data.data.pagination.total
        },
        function (error) {
          console.log("error:"+error)
        }
      );
      // this.axios.order.getOrderList(params, {
      //     cancelToken: new CancelToken(function executor(c) {
      //       cancel = c
      //     })
      //   },
      //   function (response) {
      //       let langs = Object.keys(vm.$i18n.messages)
      //       for (let l in langs) {
      //         vm.statuses[langs[l]] = [
      //           {text: vm.$t('common.all', langs[l]), value: ''},
      //           {text: vm.$t('order-phil.pending', langs[l]), value: 1},
      //           {text: vm.$t('order-phil.processing', langs[l]), value: 10},
      //           {text: vm.$t('order-phil.cooking', langs[l]), value: 5},
      //           {text: vm.$t('order-phil.delivery', langs[l]), value: 6},
      //           {text: vm.$t('order-phil.complete', langs[l]), value: 7},
      //           {text: vm.$t('order-phil.cancel', langs[l]), value: 8},
      //           {text: vm.$t('order-phil.return', langs[l]), value: 21},
      //           {text: vm.$t('order-phil.error', langs[l]), value: 4}
      //         ]
      //       vm.dataTable.items = response.data.data.items
      //       vm.dataTable.total = response.data.data.pagination.total
      //     }
      //   },
      //   function (error) {
      //     console.log("error:"+error)
      // });
    },
    listOrderStatus:function(){
      let vm=this
      vm.axios.order.getListOrderStatus(function (response) {
        let data = response.data.data
        if(data){
          let orderComplete = [7, 9]
          let flag = {}
          let langs = Object.keys(vm.$i18n.messages)
          for (let l in langs) {
            let lang = langs[l]
            vm.statuses[lang]=[]
            vm.advances[lang]=[]

            vm.statuses[lang].push({text: vm.$t('common.all', lang), value: ''})
            vm.advances[lang].push({text: vm.$t('common.all', lang), value: ''})
            vm.advances[lang].push({text: vm.$t('order.advance', lang), value: '1'})
            vm.advances[lang].push({text: vm.$t('order.now', lang), value: '0'})
            for (let item in data) {
              let json=data[item].status.json_name
              if (orderComplete.indexOf(data[item].status_id) >= 0) {
                if (!flag[lang]) {
                  flag[lang] = true
                  vm.statuses[lang].push({text: json[lang], value: orderComplete.join(',')})
                }
              } else {
                vm.statuses[lang].push({text: json[lang], value: data[item].status_id})
              }
            }
          }
        }
      })
    },
    getListOutlet () {
      vm.axios.outlet.getStoreListUnlimit('?disposition=ALL', function (respone) {
        let result = respone.data.data.items
        for (let i in result) {
          let storeValue = {
            text: result[i].code + ' - ' + result[i].name,
            value: result[i].code
          }
          vm.outletsList.push(storeValue)
        }
      }, error => {
        console.log(error)
      })
    }
  },
  created: function () {
    vm = this
    this.isNzMarket = localStorage.getItem('clientID') === vm.client_uuid.nz
    let langs = Object.keys(vm.$i18n.messages);
    const defaultChannels = [{text: 'Web', value: 'Web'}, {text: 'iOS', value: 'iOS'}, {text: 'Android', value: 'Android'}];
  
    let fetchChannelsByClient = [];
    switch (vm.client) {
      case vm.client_uuid.jp:
        fetchChannelsByClient = [{text: 'iPad', value: 'iPadOS'}, {text: 'Demaecan mobile', value: 'mobile'}, {text: 'Demaecan PC', value: 'PC'}, {text: 'Rakuten', value: 'rakuten'}, {text: 'Uber', value: 'uber'}];
        break;
      case vm.client_uuid.sg:
      case vm.client_uuid.bz:  
      case vm.client_uuid.my:  
        fetchChannelsByClient = [{text: 'iPad', value: 'iPadOS'}];
        break;

      case vm.client_uuid.nz:  
        fetchChannelsByClient = [{text: '0800', value: '0800'}];
        break;
      case vm.client_uuid.pr:  
        fetchChannelsByClient = [{text: '0800', value: '0800'}, {text: 'Call Center', value: 'CallCenter'}];
        break;  
      case vm.client_uuid.ph:
      case vm.client_uuid.kw:
      case vm.client_uuid.pe:
      case vm.client_uuid.mx:   
        // using default channels
        break;
      default:
        break;
    }

    for (let lang in langs) {
      vm.sale_channels[langs[lang]] = [
        {text: vm.$t('common.all', langs[lang]), value: ''},
        ...defaultChannels,
        ...fetchChannelsByClient
      ]
    }

    this.xToken = this.$auth.user().token
    this.debouncedInput = _.debounce(this.refreshData, 240)
    let CancelToken = vm.axios.CancelToken
    this.dataTable.source = CancelToken.source()

    for (let i in this.dataTable.fields) {
      if (this.dataTable.fields[i].filter != null && this.dataTable.fields[i].filter == true && this.checkShowByConfig(this.dataTable.fields[i].name)) {
        this.filter.options.push(this.dataTable.fields[i])
      }
      if (this.dataTable.fields[i].sort != null && this.dataTable.fields[i].sort == true && this.dataTable.sort.field == null) {
        this.dataTable.sort = {
          field: 'created_at',
          type: 'desc'
        }
      }
    }

    for (let l in langs) {
      vm.order_types[langs[l]] = [
        {text: vm.$t('common.all', langs[l]), value: ''},
        {text: vm.$t('common.delivery', langs[l]), value: 'D'},
        {text: vm.$t('common.takeaway', langs[l]), value: 'C'}
      ]
    }
    let filter = this.$session.get('filter', null)
    if (filter != null && this.$route.query && this.$route.query.rollback) {
      for (let i in filter.filter) {
        this.filter[i] = filter.filter[i]
      }
      for (let i in filter.dataTable) {
        this.dataTable[i] = filter.dataTable[i]
      }
    }
    vm.getListOutlet()
    vm.listOrderStatus()
    vm.refreshData()
  },
  beforeDestroy: function () {
    clearInterval(this.intervalLoadOrder)
    this.$session.set('filter', {
      filter: this.filter,
      dataTable: {
        sort: {
          field: this.dataTable.sort.field,
          type: this.dataTable.sort.type
        },
        currentPage: this.dataTable.currentPage,
        perPage: this.dataTable.perPage
      }
    })
  },
  watch: {
    'filter.key': function (val) {
      this.debouncedInput()
    },
    'dataTable.currentPage': function (val) {
      this.refreshData()
    },
    'filter.outlet_name': function (val) {
      this.refreshData()
    },
    'dataTable.perPage': function (val) {
      this.refreshData()
    },
    'filter.status': function (val) {
      this.refreshData()
    },
    'filter.code': function (val) {
      this.refreshData()
    },
    'filter.order_type': function (val) {
      this.refreshData()
    },
    'filter.sale_channel': function (val) {
      this.refreshData();
    },
    'filter.advance': function (val) {
      this.refreshData()
    }
  },
  computed : {
    date_locale : function () {
      let format = this.format_date_range_locale()
      if(this.$refs.drange){
        this.$refs.drange.locale = format
      }
      return format
    },
    ranges : function () {
      return this.format_date_ranges()
    },
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
  strong {
    font-weight: 600;
  }
  .confirm-address{
    font-size: 15px;
  }
  .store-operation{
    font-size: 15px;
    font-weight: 500;
  }
  .set-table-height{
    min-height: 500px;
  }
  .status-ordered-red{
    background-color: #FF0000;
    color: white;
    cursor: pointer;
    font-size: 13px;
  }

  .status-processed-green{
    background-color: #32CD32;
    color: white;
    cursor: pointer;
    font-size: 13px;
  }
  .status-cancelled-gray{
    background-color: #696969;
    color: white;
    cursor: pointer;
    font-size: 13px;
  }
  .payment-method-swipe{
    background-color: #87CEFA;
    color: white;
    cursor: pointer;
  }
  .payment-method-credit{
    background-color: #FFA07A;
    color: white;
    cursor: pointer;
  }
</style>
<style>
  .select-filter-outlet {
    position: relative;
    -webkit-box-flex: 1;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    width: 1% !important;
    margin-bottom: 0;
  }
  .select-filter-outlet .multiselect__tags{
    border-radius: 0;
  }
  .order-details {
    width: 100%;
  }
  .order-details .item-row {
    line-height: 25px;
    width: 100%;
    clear: both;
    margin-top: 6px;
  }
  .order-details .item-name {
    width: 70%;
    font-weight: 600;
    float: left;
  }
  .order-details .option-name {
    padding-left: 10px;
    width: 70%;
    float: left;
  }
  .order-details .topping-name {
    padding-left: 10px;
    width: 70%;
    float: left;
  }
  .order-details .item-price {
    width: 30%;
    float: left;
    text-align: right;
  }
  .order-menu-list div.order-menu-list{
    margin-top: 30px;
  }

  .order-menu-list div.row{
    margin-top: 10px;
  }
  .order-menu-list div.td-row{
    margin-top: 0px;
  }

  .btn-action-view{min-width: 131px;}
  .btn-edit-cancel{min-width: 82px;}

  .view-modal-lg .row-header{
    font-weight: 500;
    font-size: 18px;
  }

  .view-modal-lg div.row-content{
    border-top: 1px #d1d4d7 solid;
  }
  .view-modal-lg div.row-content div.col-content1{
    border-right: 1px #d1d4d7 solid;
  }
  .view-modal-lg div.row-content div.col-content2{
    border-right: 1px #d1d4d7 solid;
    line-height: 30px;
  }
  .view-modal-lg div.row-content div.col-content3{
    border-right: 1px #d1d4d7 solid;
  }
  .view-modal-lg .row-process{
    background-color: #dce8f5;
    min-height: 45px;
    font-size: 18px;
  }
  .view-modal-lg .row-confirm-detail{
    border-bottom: 1px #d1d4d7 solid;
    padding-bottom: 20px;
  }
  .view-modal-lg .row-footer{
  }

  .modal .modal-huge {
    max-width: 1200px;
    width: 1200px;
  }

  .modal .modal-huge-extra {
    max-width: 1200px;
    width: 1200px;
  }
</style>
<style scoped>
  .mrt-10 {
    margin-top: 10px;
  }
  .badge--pending {
    background-color: #FF0000;
  }
  .pdfobject-container { height: 75rem; border: 1rem solid rgba(0,0,0,.1); }
</style>



// WEBPACK FOOTER //
// src/views/admin/order/ListErrors.vue